import { render, staticRenderFns } from "./Exchange.vue?vue&type=template&id=56fc78da&scoped=true"
import script from "./Exchange.vue?vue&type=script&lang=js"
export * from "./Exchange.vue?vue&type=script&lang=js"
import style0 from "./Exchange.vue?vue&type=style&index=0&id=56fc78da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fc78da",
  null
  
)

export default component.exports